
export enum WidgetDisplayMode {
    WIDE = "WIDE",
    TALL = "TALL"
}
